import { useContext } from "react";
import { playerContext } from "./playerContext";

export const usePlayer = () => useContext(playerContext).player;
